import Menu from 'Models/Menu';

export default [
  Menu.createNewAsset,
  // Menu.assetsMapView,
  Menu.setHomePage,
  Menu.checkUpdate,
  Menu.assetsHelp,
];
